import { Box } from "@chakra-ui/react";
import React from "react";
import Header from "../../../../components/header";
import Banner from "./components/banner";
import Footer from "../../../../components/footer";
import DownloadGuide from "./components/downloadGuide";

const DownloadPages = () => {
  return (
    <Box>
      <Header />
      <Banner />
      <DownloadGuide />
      <Footer />
    </Box>
  );
};

export default DownloadPages;
